import { Ability } from '@casl/ability';

export const ability = new Ability();
export const abilityPlugin = (store) => store.subscribe((mutation) => {
  if (mutation.type === 'auth/SET_ROLE_DATA') {
    ability.update(mutation.payload.rights);
  }
});
